import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
import type { TryStandardUpflowV2ExperimentTreatmentModalProps } from './TryStandardUpflowV2ExperimentTreatmentModal.tsx';

export const TryStandardUpflowV2ExperimentTreatmentModalLoadable: LoadableType<TryStandardUpflowV2ExperimentTreatmentModalProps> =
	LoadableLazy({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-upflowV2-experiment-treatment-modal-with-error-boundary" */ './UpflowV2ExperimentErrorBoundary.tsx'
				)
			).TryStandardUpflowV2ExperimentTreatmentModalWithErrorBoundary,
	});
